import { NgModule } from '@angular/core';
import { SharedModule } from '@vendure/admin-ui/core';

import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { ReviewStateLabelComponent } from './components/review-state-label/review-state-label.component';
import { ReviewHistogramComponent } from './components/review-histogram/review-histogram.component';

@NgModule({
    imports: [SharedModule, StarRatingComponent, ReviewStateLabelComponent, ReviewHistogramComponent],
    exports: [StarRatingComponent, ReviewStateLabelComponent, ReviewHistogramComponent, SharedModule],
})
export class ReviewsSharedModule {}
